import React, { useRef } from "react";
import classNames from "classnames";

/*  **IMPORTANT NOTE BEFORE USING THIS COMPONENT  */
/* ONLY WORKS WITH HOOK FORM CONTEXT WRAPPED ON THE PARENT COMPONENT  */

const inputClass =
  "appearance-none block w-full font-display border border-gray-400 rounded py-3 px-4 mb-3 leading-tight focus:outline-none bg-disabledInput";

const labelClass =
  "block tracking-wide text-black font-display text-sm leading-5 font-medium mb-2";

const inputErrorClass = "border border-red-500 b-2 text-red-500";

const OrganisationDetailsForm = ({
  disableAll,
  formState,
  debouncedGetOrganisation,
}) => {
  const gstRef = useRef(null);
  const panRef = useRef(null);
  const { organisationType, organisation, organisationError } = formState;

  const handleInputChange = (event) => {
    if (organisationType === "GST") {
      debouncedGetOrganisation(gstRef.current.value);
    } else {
      debouncedGetOrganisation(panRef.current.value);
    }
  };

  return (
    <div>
      {/* Load Organisation Field Conditionally */}

      {organisationType ? (
        organisationType === "GST" ? (
          <div className="md:w-1/2 w-full mb-6">
            <label className={labelClass} htmlFor="gstNumber">
              GSTIN Number
            </label>
            <input
              className={classNames({
                [inputClass]: true,
                [inputErrorClass]: organisationError,
              })}
              id="gstNumber"
              placeholder="GST Number"
              name="gstNumber"
              ref={gstRef}
              defaultValue={(organisation && organisation.gstNumber) || ""}
              onChange={handleInputChange}
              disabled={disableAll}
            />
            {organisationError && (
              <div className="text-xs text-red-500 flex flex-row-reverse">
                <span>{organisationError}</span>
              </div>
            )}
          </div>
        ) : (
          <div className="md:w-1/2 w-full mb-6">
            <label className={labelClass} htmlFor="panNumber">
              PAN NUMBER
            </label>
            <input
              className={classNames({
                [inputClass]: true,
                [inputErrorClass]: organisationError,
              })}
              id="panNumber"
              placeholder="PAN Number"
              name="panNumber"
              ref={panRef}
              defaultValue={(organisation && organisation.panNumber) || ""}
              onChange={handleInputChange}
              disabled={disableAll}
            />
            {organisationError && (
              <div className="text-xs text-red-500 flex flex-row-reverse">
                <span>{organisationError}</span>
              </div>
            )}
          </div>
        )
      ) : null}

      {/* Same line inputs */}

      {organisation && (
        <>
          <div className="md:flex">
            <div className="md:w-1/2 w-full mb-6">
              <label
                className="block truncate tracking-wide text-black font-display text-sm leading-5 font-medium mb-2"
                htmlFor="org-name"
              >
                Registered Organisation Name
              </label>
              <input
                className={inputClass}
                id="org-name"
                name="registeredOrganisationName"
                placeholder="Registered Organisation Name"
                disabled
                value={organisation.registeredCompanyName || ""}
              />
            </div>
            <div className="md:w-1/2 w-full mb-6 md:ml-6">
              <label className={labelClass} htmlFor="landline-num">
                Primary Landline Number
              </label>
              <input
                className={inputClass}
                id="landline-num"
                placeholder="Primary Landline"
                disabled
                value={organisation.landlineNumber || ""}
              />
            </div>
          </div>
          <div className="w-full mb-6">
            <label className={labelClass} htmlFor="company-address">
              Registered Company Address
            </label>
            <input
              className={inputClass}
              id="company-address"
              placeholder="Registered Company Address"
              disabled
              value={organisation.registeredAddress}
            />
          </div>
          {/* Same line inputs */}
          <div className="md:flex">
            <div className="md:w-1/2 w-full mb-6">
              <label className={labelClass} htmlFor="email-id">
                Registered Email ID
              </label>
              <input
                className={inputClass}
                id="email-id"
                placeholder="Email ID"
                disabled
                value={organisation.registeredEmail || ""}
              />
            </div>
            <div className="md:w-1/2 w-full mb-6 md:ml-6">
              <label className={labelClass} htmlFor="mobile-number">
                Mobile Phone Number
              </label>
              <input
                className={inputClass}
                id="mobile-number"
                placeholder="Mobile Number"
                disabled
                value={organisation.phoneNumber || ""}
              />
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default OrganisationDetailsForm;
